import React from "react"

const Switch = props => {
  //   let whatup = () => {
  //     alert("what up")
  //   }

  // const doSomething = () => {
  //   console.log("yo")
  // }

  return (
    <div className="switch-wrapper">
      <div className="switch">
        <input
          id="switch-1"
          type="checkbox"
          className="switch-input"
          onClick={props.onClick}
          defaultChecked={props.checked}
        />
        <label htmlFor="switch-1" className="switch-label">
          Switch
        </label>
      </div>
      <span className={props.checked ? "faux-label on" : "faux-label off"}>
        Details {props.checked ? "On" : "Off"}
      </span>
    </div>
  )
}

export default Switch
